import { Compass, FolderKanban, Library } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ContainerKind, ProjectStatus } from '@cerebro-diem/core';

export const CONTAINER_ICONS: Record<ContainerKind, LucideIcon> = {
  project: FolderKanban,
  area: Compass,
  resource: Library,
};

/** The statuses a live project can have; done means Complete & archive. */
export const PROJECT_STATUSES: readonly ProjectStatus[] = ['active', 'waiting', 'blocked', 'someday'];

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  active: 'Active',
  waiting: 'Waiting',
  blocked: 'Blocked',
  someday: 'Someday',
  done: 'Done',
};
